/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CheckoutSessionStatusResponse interface.
 */
export function instanceOfCheckoutSessionStatusResponse(value) {
    if (!('paymentStatus' in value) || value['paymentStatus'] === undefined)
        return false;
    if (!('pending' in value) || value['pending'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    return true;
}
export function CheckoutSessionStatusResponseFromJSON(json) {
    return CheckoutSessionStatusResponseFromJSONTyped(json, false);
}
export function CheckoutSessionStatusResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'paymentStatus': json['payment_status'],
        'pending': json['pending'],
        'status': json['status'],
    };
}
export function CheckoutSessionStatusResponseToJSON(json) {
    return CheckoutSessionStatusResponseToJSONTyped(json, false);
}
export function CheckoutSessionStatusResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'payment_status': value['paymentStatus'],
        'pending': value['pending'],
        'status': value['status'],
    };
}
